import LabelLeftRight from './LabelLeftRight';

export { LabelLeftRight };
